// hooks/useWhatsappActivityListData.ts
import { getAiEquipmentTrackingWrongInfo } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useAiEquipmentTrackingListData = () => {
    const query = useDataQuery(['ai-equipment-tracking'], () => getAiEquipmentTrackingWrongInfo());

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useAiEquipmentTrackingListData;
